<template>
  <div>
    <div class="webting">
      <div class="control-item" @click="replace">
        <div class="control-item-title">
          添加
        </div>
      </div>
      <div class="control-item" @click="fullscreen">
        <div class="control-item-icon">
          <text class="icon iconfont icon-tupian"></text>
        </div>
        <div class="control-item-title">
          全屏
        </div>
      </div>

    </div>
  </div>

</template>

<script>
  import {
    mapState,
  } from 'vuex'

  export default {
    methods: {
      replace() {
        this.$emit('edit')
      },
      fullscreen() {
        this.$emit('fullscreen')
      },
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      })
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .webting {
    height: 50px;
    border-top: 1px solid $uni-text-color-placeholder;
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    display: flex;
    z-index: 30;
    background: $uni-text-color-inverse;

    .control-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 50px;

      .control-item-title {
        font-size: 14px;
      }

      .control-item-icon {
      }
    }
    .control-item-animation {
      position: absolute;
      width: 100%;
      bottom: -100px;
      left: 0;
      height: 50px;
      background: $uni-border-bottom-color;
      z-index: 5;
      transition: bottom 1s;
      overflow: auto;
      display: flex;
      align-items: center;
      padding: 0 10px;

      .a {
        background: #ff0000 !important;
        border-radius: 5px;
      }

      .control-item-view {
        height: 25px;
        line-height: 25px;
        min-width: 100px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 2 upx solid $uni-text-color-placeholder;
        color: $uni-text-color-inverse;
      }

      .control-item-view:nth-of-type(1) {
        border-left: none;
      }
    }

  }


  .effect-show {
    bottom: 50px;
  }
</style>
